import React, { useState } from "react";

const ENCRYPTION_KEY = "RAJSREE24062014";
const SALT = new Uint8Array([
  0x49, 0x76, 0x61, 0x6e, 0x20, 0x4d,
  0x65, 0x64, 0x76, 0x65, 0x64, 0x65, 0x76,
]);

async function deriveKeyAndIV() {
  const enc = new TextEncoder();
  const keyMaterial = await crypto.subtle.importKey(
    "raw",
    enc.encode(ENCRYPTION_KEY),
    { name: "PBKDF2" },
    false,
    ["deriveBits"]
  );
  // Rfc2898DeriveBytes defaults: 1000 iterations, SHA-1
  const bits = await crypto.subtle.deriveBits(
    { name: "PBKDF2", salt: SALT, iterations: 1000, hash: "SHA-1" },
    keyMaterial,
    (32 + 16) * 8  // 32 bytes key + 16 bytes IV
  );
  const keyBytes = bits.slice(0, 32);
  const ivBytes  = bits.slice(32, 48);
  const aesKey = await crypto.subtle.importKey(
    "raw", keyBytes, { name: "AES-CBC" }, false, ["encrypt", "decrypt"]
  );
  return { aesKey, iv: ivBytes };
}

// Mirrors Encoding.Unicode (UTF-16 LE) used in VB.NET
function toUTF16LE(str) {
  const buf = new Uint8Array(str.length * 2);
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    buf[i * 2]     = code & 0xff;
    buf[i * 2 + 1] = (code >> 8) & 0xff;
  }
  return buf;
}

function fromUTF16LE(bytes) {
  let result = "";
  for (let i = 0; i < bytes.length; i += 2) {
    result += String.fromCharCode(bytes[i] | (bytes[i + 1] << 8));
  }
  return result;
}

export async function vbCrypt(clearText) {
  try {
    const { aesKey, iv } = await deriveKeyAndIV();
    const clearBytes = toUTF16LE(clearText);
    const encBytes = await crypto.subtle.encrypt(
      { name: "AES-CBC", iv }, aesKey, clearBytes
    );
    return btoa(String.fromCharCode(...new Uint8Array(encBytes)));
  } catch {
    return "";
  }
}

export async function vbDecrypt(cipherText) {
  try {
    const { aesKey, iv } = await deriveKeyAndIV();
    const cipherBytes = Uint8Array.from(atob(cipherText), c => c.charCodeAt(0));
    const decBytes = await crypto.subtle.decrypt(
      { name: "AES-CBC", iv }, aesKey, cipherBytes
    );
    return fromUTF16LE(new Uint8Array(decBytes));
  } catch {
    return "";
  }
}